module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"plan":"Ваш тариф","changePlan":"Изменить тариф"}}')
  delete Component.options._Ctor
}
